import { render, staticRenderFns } from "./ToMghrwc.vue?vue&type=template&id=355dd956&scoped=true&"
import script from "./ToMghrwc.vue?vue&type=script&lang=ts&"
export * from "./ToMghrwc.vue?vue&type=script&lang=ts&"
import style0 from "./ToMghrwc.vue?vue&type=style&index=0&id=355dd956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355dd956",
  null
  
)

export default component.exports